var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNirmaanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 18,
    viewBox: "0 0 80 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4296 14.4082H72.838V5.56579H74.2528V6.89215H74.6065C74.9307 5.90474 75.7707 5.34473 77.0529 5.34473C79.1161 5.34473 80.0004 6.75951 80.0004 8.73431V14.4082H78.4087V9.07327C78.4087 7.54059 77.8782 6.70056 76.7139 6.70056C75.2697 6.70056 74.4296 7.98271 74.4296 9.64803V14.4082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9608 14.6292C64.6913 14.6292 63.3944 12.8166 63.3944 9.98699C63.3944 7.17216 64.6766 5.34473 66.9903 5.34473C68.3167 5.34473 69.1125 6.00791 69.422 6.7153H69.7757V5.56579H71.1905V14.4082H69.7757V13.2587H69.422C69.1125 13.9661 68.3167 14.6292 66.9608 14.6292ZM67.2409 13.3029C68.7146 13.3029 69.643 11.9765 69.643 9.98699C69.643 7.99745 68.7146 6.67109 67.2409 6.67109C65.8113 6.67109 65.0155 7.87955 65.0155 9.98699C65.0155 12.0944 65.8113 13.3029 67.2409 13.3029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1212 14.6292C55.8517 14.6292 54.5548 12.8166 54.5548 9.98699C54.5548 7.17216 55.837 5.34473 58.1507 5.34473C59.4771 5.34473 60.2729 6.00791 60.5824 6.7153H60.9361V5.56579H62.3509V14.4082H60.9361V13.2587H60.5824C60.2729 13.9661 59.4771 14.6292 58.1212 14.6292ZM58.4013 13.3029C59.875 13.3029 60.8034 11.9765 60.8034 9.98699C60.8034 7.99745 59.875 6.67109 58.4013 6.67109C56.9717 6.67109 56.1759 7.87955 56.1759 9.98699C56.1759 12.0944 56.9717 13.3029 58.4013 13.3029Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1972 14.4082H41.6056V5.56579H43.0204V6.90688H43.3741C43.6393 5.90475 44.4352 5.34473 45.6436 5.34473C46.911 5.34473 47.7068 5.94896 48.09 6.90688H48.4437C48.7679 5.90475 49.5932 5.34473 50.8606 5.34473C52.806 5.34473 53.6313 6.75951 53.6313 8.73431V14.4082H52.0396V9.07327C52.0396 7.54059 51.568 6.70056 50.4922 6.70056C49.1658 6.70056 48.4142 7.98271 48.4142 9.64803V14.4082H46.8226V9.07327C46.8226 7.54059 46.351 6.70056 45.2752 6.70056C43.9488 6.70056 43.1972 7.98271 43.1972 9.64803V14.4082Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9277 14.4084H36.3361V5.56596H37.7508V7.06917H38.1045C38.2814 6.3323 38.7235 5.47754 40.492 5.47754H40.7867V6.98075H40.3446C38.5761 6.98075 37.9277 7.86499 37.9277 9.81031V14.4084Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6562 14.4083H33.0646V5.56592H34.6562V14.4083Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4213 14.4082H21.9181V2.91309H24.9245L29.4931 13.0966H29.8468V2.91309H31.35V14.4082H28.3436L23.775 4.22471H23.4213V14.4082Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.8243,
    y: 2.15967,
    width: 2.07372,
    height: 2.07372,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 6.58179,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint0_linear_138_202)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.91016,
    y: 5.1665,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint1_linear_138_202)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3242,
    y: 3.75098,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint2_linear_138_202)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 3.75098,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint3_linear_138_202)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1561,
    y: 5.1665,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint4_linear_138_202)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07812,
    y: 6.58179,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint5_linear_138_202)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07812,
    y: 5.1665,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint6_linear_138_202)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07812,
    y: 3.75098,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint7_linear_138_202)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 2.33569,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint8_linear_138_202)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.91016,
    y: 0.920166,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint9_linear_138_202)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5.66406,
    y: 7.99707,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint10_linear_138_202)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.24817,
    y: 6.58179,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint11_linear_138_202)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 2.83203,
    y: 5.1665,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint12_linear_138_202)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 2.83203,
    y: 3.75098,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint13_linear_138_202)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4.24817,
    y: 2.33569,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint14_linear_138_202)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 5.66406,
    y: 9.4126,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint15_linear_138_202)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4.24817,
    y: 9.4126,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint16_linear_138_202)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 2.83203,
    y: 9.4126,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint17_linear_138_202)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1.41797,
    y: 7.99707,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint18_linear_138_202)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 6.58179,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint19_linear_138_202)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07812,
    y: 10.8281,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint20_linear_138_202)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 5.66406,
    y: 12.2434,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint21_linear_138_202)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 4.24817,
    y: 13.6589,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint22_linear_138_202)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 2.83203,
    y: 13.6589,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint23_linear_138_202)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1.41797,
    y: 12.2434,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint24_linear_138_202)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 10.8281,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint25_linear_138_202)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 12.2434,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint26_linear_138_202)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49414,
    y: 13.6589,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint27_linear_138_202)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07812,
    y: 15.0742,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint28_linear_138_202)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 5.66406,
    y: 16.4897,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint29_linear_138_202)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 9.91016,
    y: 9.4126,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint30_linear_138_202)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3242,
    y: 10.8281,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint31_linear_138_202)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 12.2434,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint32_linear_138_202)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 13.6589,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint33_linear_138_202)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3242,
    y: 15.0742,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint34_linear_138_202)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 9.91016,
    y: 7.99707,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint35_linear_138_202)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3242,
    y: 7.99707,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint36_linear_138_202)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 7.99707,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint37_linear_138_202)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1561,
    y: 9.4126,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint38_linear_138_202)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5723,
    y: 10.8281,
    width: 1.41541,
    height: 1.41541,
    fill: "url(#paint39_linear_138_202)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_138_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.49219,
    y: 5.75635,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9082,
    y: 4.34082,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3223,
    y: 2.92554,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7383,
    y: 2.92554,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1541,
    y: 4.34082,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07617,
    y: 5.75635,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07617,
    y: 4.34082,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07617,
    y: 2.92554,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.49219,
    y: 1.51001,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9082,
    y: 0.0947266,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.66211,
    y: 7.17163,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.24634,
    y: 5.75635,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.83008,
    y: 4.34082,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.83008,
    y: 2.92554,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.24634,
    y: 1.51001,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.66211,
    y: 8.58716,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.24634,
    y: 8.58716,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.83008,
    y: 8.58716,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.41602,
    y: 7.17163,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.75635,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07617,
    y: 10.0024,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.66211,
    y: 11.418,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.24634,
    y: 12.8333,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.83008,
    y: 12.8333,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.41602,
    y: 11.418,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.49219,
    y: 10.0024,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.49219,
    y: 11.418,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.49219,
    y: 12.8333,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07617,
    y: 14.2485,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.66211,
    y: 15.6638,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9082,
    y: 8.58716,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3223,
    y: 10.0024,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7383,
    y: 11.418,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7383,
    y: 12.8333,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3223,
    y: 14.2485,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9082,
    y: 7.17163,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3223,
    y: 7.17163,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7383,
    y: 7.17163,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1541,
    y: 8.58716,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5703,
    y: 10.0024,
    width: 1.41541,
    height: 1.41541,
    fill: "#B866F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_138_202",
    x: 0,
    y: -2.62344,
    width: 16.9857,
    height: 19.7028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.71817
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.10658
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647305 0 0 0 0 0.296562 0 0 0 0 0.9125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_138_202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_138_202",
    x1: 9.20184,
    y1: 6.58179,
    x2: 9.20184,
    y2: 7.99719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_138_202",
    x1: 10.6179,
    y1: 5.1665,
    x2: 10.6179,
    y2: 6.58191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_138_202",
    x1: 12.0319,
    y1: 3.75098,
    x2: 12.0319,
    y2: 5.16638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_138_202",
    x1: 13.4479,
    y1: 3.75098,
    x2: 13.4479,
    y2: 5.16638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_138_202",
    x1: 14.8638,
    y1: 5.1665,
    x2: 14.8638,
    y2: 6.58191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_138_202",
    x1: 7.78583,
    y1: 6.58179,
    x2: 7.78583,
    y2: 7.99719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_138_202",
    x1: 7.78583,
    y1: 5.1665,
    x2: 7.78583,
    y2: 6.58191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_138_202",
    x1: 7.78583,
    y1: 3.75098,
    x2: 7.78583,
    y2: 5.16638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_138_202",
    x1: 9.20184,
    y1: 2.33569,
    x2: 9.20184,
    y2: 3.7511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_138_202",
    x1: 10.6179,
    y1: 0.920166,
    x2: 10.6179,
    y2: 2.33557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_138_202",
    x1: 6.37177,
    y1: 7.99707,
    x2: 6.37177,
    y2: 9.41248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_138_202",
    x1: 4.95587,
    y1: 6.58179,
    x2: 4.95587,
    y2: 7.99719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_138_202",
    x1: 3.53973,
    y1: 5.1665,
    x2: 3.53973,
    y2: 6.58191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_138_202",
    x1: 3.53973,
    y1: 3.75098,
    x2: 3.53973,
    y2: 5.16638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_138_202",
    x1: 4.95587,
    y1: 2.33569,
    x2: 4.95587,
    y2: 3.7511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_138_202",
    x1: 6.37177,
    y1: 9.4126,
    x2: 6.37177,
    y2: 10.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_138_202",
    x1: 4.95587,
    y1: 9.4126,
    x2: 4.95587,
    y2: 10.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_138_202",
    x1: 3.53973,
    y1: 9.4126,
    x2: 3.53973,
    y2: 10.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_138_202",
    x1: 2.12567,
    y1: 7.99707,
    x2: 2.12567,
    y2: 9.41248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_138_202",
    x1: 0.709656,
    y1: 6.58179,
    x2: 0.709656,
    y2: 7.99719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_138_202",
    x1: 7.78583,
    y1: 10.8281,
    x2: 7.78583,
    y2: 12.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_138_202",
    x1: 6.37177,
    y1: 12.2434,
    x2: 6.37177,
    y2: 13.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_138_202",
    x1: 4.95587,
    y1: 13.6589,
    x2: 4.95587,
    y2: 15.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_138_202",
    x1: 3.53973,
    y1: 13.6589,
    x2: 3.53973,
    y2: 15.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_138_202",
    x1: 2.12567,
    y1: 12.2434,
    x2: 2.12567,
    y2: 13.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_138_202",
    x1: 9.20184,
    y1: 10.8281,
    x2: 9.20184,
    y2: 12.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_138_202",
    x1: 9.20184,
    y1: 12.2434,
    x2: 9.20184,
    y2: 13.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_138_202",
    x1: 9.20184,
    y1: 13.6589,
    x2: 9.20184,
    y2: 15.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_138_202",
    x1: 7.78583,
    y1: 15.0742,
    x2: 7.78583,
    y2: 16.4896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_138_202",
    x1: 6.37177,
    y1: 16.4897,
    x2: 6.37177,
    y2: 17.9052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_138_202",
    x1: 10.6179,
    y1: 9.4126,
    x2: 10.6179,
    y2: 10.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_138_202",
    x1: 12.0319,
    y1: 10.8281,
    x2: 12.0319,
    y2: 12.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_138_202",
    x1: 13.4479,
    y1: 12.2434,
    x2: 13.4479,
    y2: 13.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_138_202",
    x1: 13.4479,
    y1: 13.6589,
    x2: 13.4479,
    y2: 15.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_138_202",
    x1: 12.0319,
    y1: 15.0742,
    x2: 12.0319,
    y2: 16.4896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_138_202",
    x1: 10.6179,
    y1: 7.99707,
    x2: 10.6179,
    y2: 9.41248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_138_202",
    x1: 12.0319,
    y1: 7.99707,
    x2: 12.0319,
    y2: 9.41248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_138_202",
    x1: 13.4479,
    y1: 7.99707,
    x2: 13.4479,
    y2: 9.41248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_138_202",
    x1: 14.8638,
    y1: 9.4126,
    x2: 14.8638,
    y2: 10.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_138_202",
    x1: 16.28,
    y1: 10.8281,
    x2: 16.28,
    y2: 12.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNirmaanLogo);
export default __webpack_public_path__ + "static/media/Nirmaan_Logo.1d1352bad31c2dc6e767b7a43365bc9f.svg";
export { ForwardRef as ReactComponent };